// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1Rwoa","tab":"ProcedureTabs_tab__1TRHz"};